import React, { useState, useEffect } from 'react';
import { Row, Col, Label, Input, FormGroup, Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import uuid from 'react-uuid';
import Select, { components } from 'react-select';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

const Risk = ({ setFormErrors, handleMultiSelectRiskChange, formErrors, itemPopupRisk, riskLookupList, handleItemPopupRisk, setRiskLookupList, setItemPopupRisk, itemPopupHeader }) => {
    const roleName = localStorage.getItem("roleName");
    const isAddArchiveItem = localStorage.getItem("isAddArchiveItem");
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId")); const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [addRiskPopup, setAddRiskPopup] = useState({
        header: 'Create Custom Risk', showPopup: false, id: 0, name: '', description: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], category: [],
        openActions: 0, isActive: true
    });
    const selectOptions = [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" }
    ];
    const selectRiskOptions = [
        { value: "", label: "Select" },
        { value: "High", label: "High" },
        { value: "Medium", label: "Medium" },
        { value: "Low", label: "Low" }
        
    ];
    useEffect(() => {
        if (riskLookupList.luenterpriseTypes.filter(x => x.label == 'N/A').length > 0) {
            if (riskLookupList.luenterpriseTypes.length == 1) {
                itemPopupRisk.enterprises = riskLookupList.luenterpriseTypes.filter(x => x.label == 'N/A');
                itemPopupRisk.showEnterprise = false;
            }
            else {
                itemPopupRisk.showEnterprise = true;
            }
        }
        else {
            itemPopupRisk.showEnterprise = true;
        }

    }, [])

    const showRiskPopup = (e) => {
        e.preventDefault();
        if (itemPopupHeader.LMUIds == '' || itemPopupHeader.LMUIds == '0') {
            const errors = {};
            errors.luid = "This is mandatory!";
            setFormErrors(errors);
            return false;
        }
        else {
            setAddRiskPopup({ ...addRiskPopup, header: 'Create Custom Risk', isActive: true, id: 0, openActions: 0, showPopup: true, name: '', description: '', enterprises: [], activityGroups: [], activitySubGroups: [], contaminants: [], riskDataGroups: [], category: [] });
        }
    }
    const handleAddRiskPopupClose = (e) => {
        setAddRiskPopup({ ...addRiskPopup, showPopup: false, description: '' });
    }
    const [formDocumentErrors, setFormDocumentErrors] = useState({});
    function handleAddRiskPopupChange(event) {
        const { name, value, checked, type } = event.target;
        setAddRiskPopup({ ...addRiskPopup, [name]: type == 'checkbox' ? checked : value });
    }
    const [addingRisk, setAddingRisk] = useState(''); const [deleteRisk, setDeleteRisk] = useState('');
    const handleAddRiskPopupSave = async (e) => {
        e.preventDefault();
        setFormDocumentErrors({});
        var IsActive = true;
        const errors = {};
        var id = addRiskPopup.id;
        if (id == 0) {
            IsActive = true;
        }
        let category = '';
        if (addRiskPopup.category == null || addRiskPopup.category == undefined || addRiskPopup.category == "") {
            errors.category = "This is mandatory!";
        }
        else {
            if (Array.isArray(addRiskPopup.category)) {
                category = addRiskPopup.category[0].label;
            }
            else if (typeof addRiskPopup.category === 'object') {
                category = addRiskPopup.category.label;
            }
        }
        if (addRiskPopup.name == null || addRiskPopup.name == undefined || addRiskPopup.name == "") {
            errors.name = "This is mandatory!";
        }
        if (addRiskPopup.description == null || addRiskPopup.description == undefined || addRiskPopup.description == "") {
            errors.description = "This is mandatory!";
        }
        let enterprises = '';
        if (Array.isArray(addRiskPopup.enterprises)) {
            let enterprisesArr = [];
            addRiskPopup.enterprises.forEach(risk => {
                enterprisesArr.push(risk.value);
            })
            enterprises = enterprisesArr.join(",");
        } else {
            enterprises = addRiskPopup.enterprises.toString();
        }
        if (enterprises == null || enterprises == undefined || enterprises == "") {
            errors.enterprises = "This is mandatory!";
        }
        let contaminants = '';
        if (Array.isArray(addRiskPopup.contaminants)) {
            let contaminantsArr = [];
            addRiskPopup.contaminants.forEach(risk => {
                contaminantsArr.push(risk.value);
            })
            contaminants = contaminantsArr.join(",");
        } else {
            contaminants = addRiskPopup.contaminants.toString();
        }
        if (contaminants == null || contaminants == undefined || contaminants == "") {
            errors.contaminants = "This is mandatory!";
        }
        let riskDataGroups = '';
        if (Array.isArray(addRiskPopup.riskDataGroups)) {
            let riskDataGroupsArr = [];
            addRiskPopup.riskDataGroups.forEach(risk => {
                riskDataGroupsArr.push(risk.value);
            })
            riskDataGroups = riskDataGroupsArr.join(",");
        } else {
            riskDataGroups = addRiskPopup.riskDataGroups.toString();
        }
        if (riskDataGroups == null || riskDataGroups == undefined || riskDataGroups == "") {
            errors.riskDataGroups = "This is mandatory!";
        }
        let activityGroups = '';
        if (Array.isArray(addRiskPopup.activityGroups)) {
            let activityGroupsArr = [];
            addRiskPopup.activityGroups.forEach(risk => {
                activityGroupsArr.push(risk.value);
            })
            activityGroups = activityGroupsArr.join(",");
        } else {
            activityGroups = addRiskPopup.activityGroups.toString();
        }
        if (activityGroups == null || activityGroups == undefined || activityGroups == "") {
            errors.activityGroups = "This is mandatory!";
        }
        let activitySubGroups = '';
        if (Array.isArray(addRiskPopup.activitySubGroups)) {
            let activitySubGroupsArr = [];
            addRiskPopup.activitySubGroups.forEach(risk => {
                activitySubGroupsArr.push(risk.value);
            })
            activitySubGroups = activitySubGroupsArr.join(",");
        } else {
            activitySubGroups = addRiskPopup.activitySubGroups.toString();
        }
        if (activitySubGroups == null || activitySubGroups == undefined || activitySubGroups == "") {
            errors.activitySubGroups = "This is mandatory!";
        }
        setFormDocumentErrors(errors);
        if (Object.keys(errors).length == 0) {
            setAddingRisk(true);
            const response = await axios.get(
                '/api/Risk/SaveCustomRiskFromItem/', {
                params: {
                    farmId: farmId, id: id, name: addRiskPopup.name, description: addRiskPopup.description, enterprises: enterprises, contaminants: contaminants,
                    riskDataGroups: riskDataGroups, activityGroups: activityGroups, activitySubGroups: activitySubGroups, userId: userId, category: category,
                    IsActive: IsActive, LMUIds: itemPopupHeader.LMUIds
                }
            }
            );
            if (response.data.status) {
                setAddingRisk(false);
                setRiskLookupList({
                    ...riskLookupList, riskList: response.data.content.riskSelectList
                })
                setItemPopupRisk({ ...itemPopupRisk, riskId: response.data.content.addedRisk });
                if (addRiskPopup.header == 'Edit Custom Risk') {
                    toast.success("Risk details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                }
                else {
                    toast.success("Risk Added!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                }
                setAddRiskPopup({ ...addRiskPopup, showPopup: false });
            }
        }
    }
    const handleMultiSelectCategoryChange = (e) => {
        setAddRiskPopup({ ...addRiskPopup, category: e });
    }

    const handleMultiSelectActivitySubGroupChange = (e) => {
        setAddRiskPopup({ ...addRiskPopup, activitySubGroups: e });
    }
    const handleMultiSelectEnterpriseChange = (e) => {
        setAddRiskPopup({ ...addRiskPopup, enterprises: e });
    }
    const handleMultiSelectContaminantChange = (e) => {
        setAddRiskPopup({ ...addRiskPopup, contaminants: e });
    }
    const handleMultiSelectRiskDataGroupChange = (e) => {
        setAddRiskPopup({ ...addRiskPopup, riskDataGroups: e });
    }
    const handleMultiSelectActivityGroupChange = (e) => {
        setRiskLookupList({
            ...riskLookupList, activitySubGroups: []
        })
        var selectedActivitySubGroups = [];
        let myArrayFiltered = [];
        if (addRiskPopup.activitySubGroups != undefined && addRiskPopup.activitySubGroups.length > 0) {
            selectedActivitySubGroups = addRiskPopup.activitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
            myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        else {
            myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        setAddRiskPopup({ ...addRiskPopup, activityGroups: e, activitySubGroups: selectedActivitySubGroups });
        setRiskLookupList({
            ...riskLookupList, activitySubGroups: myArrayFiltered
        })
    }
    return (
        <>
            <Row>
                <Col sm="6">
                    <FormGroup>
                        <Label for="isRisk">Does this Item have any Risk?</Label>
                        <Input
                            bsSize="sm"
                            type="select"
                            value={itemPopupRisk.isRisk}
                            onChange={handleItemPopupRisk}
                            name="isRisk"
                            id="isRisk">
                            {selectOptions.map(Option =>
                                <option key={uuid()} value={Option.id}>{Option.label}</option>
                            )}
                        </Input>
                    </FormGroup>
                </Col>
            </Row>
            {itemPopupRisk.isRisk?.toLowerCase() == "yes" &&
                <>
                    <Row>
                        <Col sm="9">
                            <FormGroup>
                                <Label for="contaminant">Risk</Label>
                                <Select
                                    closeMenuOnSelect={false}
                                    className="dropdown"
                                    placeholder="Select Risk"
                                    defaultValue={itemPopupRisk.riskId}
                                    value={itemPopupRisk.riskId}
                                    options={riskLookupList.riskList}
                                    onChange={handleMultiSelectRiskChange}
                                    isMulti={true} hideSelectedOptions={false}
                                    isClearable
                                    components={{
                                        Option
                                    }}
                                />
                            </FormGroup>
                            {formErrors.riskSelection != undefined &&
                            <p className="errorMessage">{formErrors.riskSelection}</p>
                            }
                    </Col>
                    <Col sm="3">
                        {(roleName == 'Admin' || isAddArchiveItem == 'true') &&
                            <>
                        <br/>
                        <Button onClick={showRiskPopup} style={{ float: "right" }}  type="button" color="primary" id="btnUpdate">
                            Add Risk
                            </Button>
                            </>
                        }
                    </Col>
                    </Row>
                </>
                
            }

            <Modal contentClassName="" size="lg" style={{ maxWidth: '1250px', width: '1250px' }} isOpen={addRiskPopup.showPopup}>
                <ModalHeader toggle={handleAddRiskPopupClose}>{addRiskPopup.header}</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <label style={{ color: "black", fontSize: "16px", fontWeight: "25", fontStyle: "normal" }} class="itemTypeList-header-subtext">
                                If you have a risk on this farm which is not identified it is possible to create a custom risk with the fields below.
                            </label>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col>
                            <label style={{ color: "black", fontSize: "16px", fontWeight: "25", fontStyle: "normal" }} class="itemTypeList-header-subtext">
                                IMPORTANT NOTE: on the following pages it is also possible to create additional risks against particular items when mapped
                                (e.g. when mappig a piece of infrastruture which itself might have risk.) In this scenario there is no reason to raise a custom risk here, it may be better on the subsequent mapping pages.
                            </label>
                        </Col>
                    </Row>
                    <hr />
                    <Row>
                        <Col>

                        </Col>
                    </Row>
                    <Row>
                        <Col sm="6">
                            <FormGroup>
                                <Label style={{ textTransform: "math-auto", fontSize: "16px" }}>Category</Label>
                                <br />
                                <label class="itemTypeList-header-subtext">Select which category this risk in.</label>
                                <br /><br />
                                <Select
                                    closeMenuOnSelect={false}
                                    className="dropdown"
                                    placeholder="Select Category"
                                    value={addRiskPopup.category}
                                    options={riskLookupList.categoryList}
                                    onChange={handleMultiSelectCategoryChange}
                                    hideSelectedOptions={false}
                                    isClearable
                                    components={{
                                        Option
                                    }}
                                />
                            </FormGroup>
                            {formDocumentErrors.category != undefined &&
                                <p className="errorMessage">{formDocumentErrors.category}</p>
                            }
                        </Col>
                        <Col sm="6">
                            <FormGroup>
                                <Label style={{ textTransform: "math-auto", fontSize: "16px" }}>Enterprise(s)</Label>
                                <br />
                                <label class="itemTypeList-header-subtext">Specify which Activities / Enterprises this risk relates to.<br />
                                    The risk will only be applied to Land Units with the specified activity(s).
                                </label>
                                <Select
                                    closeMenuOnSelect={false}
                                    className="dropdown"
                                    placeholder="Select Enterprise(s)"
                                    value={addRiskPopup.enterprises}
                                    options={riskLookupList.luenterpriseTypes}
                                    onChange={handleMultiSelectEnterpriseChange}
                                    isMulti hideSelectedOptions={false}
                                    isClearable
                                    components={{
                                        Option
                                    }}
                                />
                            </FormGroup>
                            {formDocumentErrors.enterprises != undefined &&
                                <p className="errorMessage">{formDocumentErrors.enterprises}</p>
                            }
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                        <Col sm="6">
                            <FormGroup>
                                <Label style={{ textTransform: "math-auto", fontSize: "16px" }}>Details</Label>
                                <br />
                                <label class="itemTypeList-header-subtext">Give this Risk a name (generally 5 to 20 words)</label>
                                <Input type="text" name="name" id="name" value={addRiskPopup.name} onChange={handleAddRiskPopupChange} />
                            </FormGroup>
                            {formDocumentErrors.name != undefined &&
                                <p className="errorMessage">{formDocumentErrors.name}</p>
                            }
                        </Col>
                        <Col sm="6">
                            <FormGroup>
                                <Label style={{ textTransform: "math-auto", fontSize: "16px" }}>Contaminant(s)</Label>
                                <Select
                                    closeMenuOnSelect={false}
                                    className="dropdown"
                                    placeholder="Select Contaminant(s)"
                                    value={addRiskPopup.contaminants}
                                    options={riskLookupList.contaminants}
                                    onChange={handleMultiSelectContaminantChange}
                                    isMulti hideSelectedOptions={false}
                                    isClearable
                                    components={{
                                        Option
                                    }}
                                />
                            </FormGroup>
                            {formDocumentErrors.contaminants != undefined &&
                                <p className="errorMessage">{formDocumentErrors.contaminants}</p>
                            }
                        </Col>
                        <Col sm="6">
                            <FormGroup>
                                <label class="itemTypeList-header-subtext">Description can be a more detailed overview of the risk (50 to 100 words)</label>
                                <textarea name="description"
                                    value={addRiskPopup.description}
                                    onChange={handleAddRiskPopupChange}
                                    className="form-control"></textarea>
                            </FormGroup>
                            {formDocumentErrors.description != undefined &&
                                <p className="errorMessage">{formDocumentErrors.description}</p>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <label style={{ color: "black", fontSize: "18px", fontWeight: "600" }} class="itemTypeList-header-subtext"><u>Ministry for the Environment - data reporting requirements</u></label>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "5px" }}>
                        <Col>
                            <label class="itemTypeList-header-subtext">When a FreshWater Plan is certified Actions and Risks and are required to be reported and associated with Risk Data Groups and Activity Groups. For this custom risk please specify which item(s) in the list below best match this risk.</label>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                        <Col sm="6">
                            <FormGroup>
                                <Label style={{ textTransform: "math-auto", fontSize: "16px" }}>Mfe Risk Data Group(s)</Label>
                                <Select
                                    closeMenuOnSelect={false}
                                    className="dropdown"
                                    placeholder="Select Mfe Risk Data Group(s)"
                                    value={addRiskPopup.riskDataGroups}
                                    options={riskLookupList.riskDataGroups}
                                    onChange={handleMultiSelectRiskDataGroupChange}
                                    isMulti hideSelectedOptions={false}
                                    isClearable
                                    components={{
                                        Option
                                    }}
                                />
                            </FormGroup>
                            {formDocumentErrors.riskDataGroups != undefined &&
                                <p className="errorMessage">{formDocumentErrors.riskDataGroups}</p>
                            }
                        </Col>
                        <Col sm="6">
                            <FormGroup>
                                <Label style={{ textTransform: "math-auto", fontSize: "16px" }}>Mfe Activity Group(s)</Label>
                                <Select
                                    closeMenuOnSelect={false}
                                    className="dropdown"
                                    placeholder="Select Mfe Activity Group(s)"
                                    value={addRiskPopup.activityGroups}
                                    options={riskLookupList.activityGroups}
                                    onChange={handleMultiSelectActivityGroupChange}
                                    isMulti hideSelectedOptions={false}
                                    isClearable
                                    components={{
                                        Option
                                    }}
                                />
                            </FormGroup>
                            {formDocumentErrors.activityGroups != undefined &&
                                <p className="errorMessage">{formDocumentErrors.activityGroups}</p>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="6">
                            <FormGroup>
                                <Label style={{ textTransform: "math-auto", fontSize: "16px" }}>Mfe Activity sub Group(s)</Label>
                                <Select
                                    closeMenuOnSelect={false}
                                    className="dropdown"
                                    placeholder="Select Mfe Activity sub Group(s)"
                                    value={addRiskPopup.activitySubGroups}
                                    options={riskLookupList.activitySubGroups}
                                    onChange={handleMultiSelectActivitySubGroupChange}
                                    isMulti hideSelectedOptions={false}
                                    isClearable
                                    components={{
                                        Option
                                    }}
                                />
                            </FormGroup>
                            {formDocumentErrors.activitySubGroups != undefined &&
                                <p className="errorMessage">{formDocumentErrors.activitySubGroups}</p>
                            }
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    {addingRisk ?
                        <Button onClick={(e) => handleAddRiskPopupSave(e)}
                            color="success" className="button-save" style={{ float: `right`, marginLeft: '10px' }}
                            disabled
                        >
                            <Row>
                                <Col sm="6">
                                    <span>
                                        {' '}Saving
                                    </span>
                                </Col>
                                <Col sm="6">
                                    <Spinner size="sm">
                                        Saving...
                                    </Spinner>
                                </Col>
                            </Row>
                        </Button>
                        :
                        <Button className="button-save" style={{ float: `right`, marginLeft: '10px' }} onClick={(e) => handleAddRiskPopupSave(e)} color="success">
                            Save
                        </Button>
                    }
                    <Button style={{ float: `right`, marginLeft: '10px' }} onClick={handleAddRiskPopupClose} color="primary" >Cancel</Button>
                </ModalFooter>
            </Modal>

        </>

    )
}
export default Risk